// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Blocks__Utils from "./utils/Blocks__Utils.bs.js";
import * as Blocks__Common from "./common/Blocks__Common.bs.js";
import * as Renderer__Context from "@pageblocks/renderer/src/Renderer__Context.bs.js";
import * as Renderer__Version from "@pageblocks/renderer/src/Renderer__Version.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";
import * as Utils__AllOptionalParser from "@pageblocks/utils/src/Utils__AllOptionalParser.bs.js";
import * as Blocks__SettingsRnAdapter from "./utils/Blocks__SettingsRnAdapter.bs.js";
import * as Ui__BoxWithImageBackground from "@pageblocks/ui/src/boxWithImageBackground/Ui__BoxWithImageBackground.bs.js";

var blockCode = "view";

function Blocks__View$Component(props) {
  var handleAction = props.handleAction;
  var triggerActions = props.triggerActions;
  var testID = props.testID;
  var __context = props.context;
  var context = __context !== undefined ? Caml_option.valFromOption(__context) : Renderer__Context.makeEmpty();
  var settings = Renderer__Settings.deserialize(props.settings);
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  Core__Option.getOr(Core__Option.flatMap(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(triggerActions), "onHover"), Blocks__Utils.getActions), []);
  var onClickActions = Core__Option.getOr(Core__Option.flatMap(Utils__AllOptionalParser.get(Utils__AllOptionalParser.obj(triggerActions), "onClick"), Blocks__Utils.getActions), []);
  return JsxRuntime.jsx(Ui__BoxWithImageBackground.make, {
              imageTestID: Core__Option.map(testID, (function (__x) {
                      return __x.concat("-background-image");
                    })),
              kind: onClickActions.length !== 0 && handleAction !== undefined ? ({
                    NAME: "Pressable",
                    VAL: {
                      onPress: (function (param) {
                          onClickActions.forEach(function (action) {
                                handleAction(action);
                              });
                        })
                    }
                  }) : undefined,
              style: (function (_interactionState) {
                  return [
                          Blocks__SettingsRnAdapter.Style.flex(settings, context, true, undefined),
                          Blocks__SettingsRnAdapter.Style.background(settings, context),
                          Blocks__SettingsRnAdapter.Style.sizing(settings, context),
                          Blocks__SettingsRnAdapter.Style.padding(settings, context),
                          Blocks__SettingsRnAdapter.Style.margin(settings, context),
                          Blocks__SettingsRnAdapter.Style.border(settings, context),
                          Blocks__SettingsRnAdapter.Style.position(settings, context)
                        ];
                }),
              testID: testID,
              imageStyle: (function (param) {
                  var tmp = {};
                  var tmp$1 = getFloat("backgroundImageOpacity");
                  if (tmp$1 !== undefined) {
                    tmp.opacity = tmp$1;
                  }
                  return tmp;
                }),
              source: Core__Option.map(getString("backgroundImage"), (function (source) {
                      return {
                              uri: source
                            };
                    })),
              children: Core__Option.getOr(Core__Option.map(props.children, (function (children) {
                          return function (_interactionState) {
                            return children;
                          };
                        })), (function (_interactionState) {
                      return null;
                    })),
              updateChildProps: Blocks__Utils.updateBoxChildPropsToApplyOpacityOnHighlight
            });
}

var Component = {
  make: Blocks__View$Component
};

var descriptor_meta = {
  version: 1,
  minRendererVersion: Renderer__Version.current
};

var descriptor_declaredTriggers = [
  {
    code: "onClick",
    name: "On Click"
  },
  {
    code: "onHover",
    name: "On Hover"
  }
];

var descriptor_declaredSettings = [
  {
    code: "testGroup",
    name: "Test Group",
    settings: [
      {
        code: "users",
        name: "Users",
        dataType: {
          TAG: "List",
          _0: {
            itemSchema: [
              {
                key: "name",
                dataType: {
                  TAG: "String",
                  _0: {}
                }
              },
              {
                key: "surname",
                dataType: {
                  TAG: "String",
                  _0: {}
                }
              },
              {
                key: "addresses",
                dataType: {
                  TAG: "List",
                  _0: {
                    itemSchema: [
                      {
                        key: "state",
                        dataType: {
                          TAG: "String",
                          _0: {}
                        }
                      },
                      {
                        key: "city",
                        dataType: {
                          TAG: "String",
                          _0: {}
                        }
                      },
                      {
                        key: "streetLines",
                        dataType: {
                          TAG: "List",
                          _0: {
                            itemSchema: [
                              {
                                key: "street",
                                dataType: {
                                  TAG: "String",
                                  _0: {}
                                }
                              },
                              {
                                key: "aptNo",
                                dataType: {
                                  TAG: "Float",
                                  _0: {}
                                }
                              }
                            ],
                            defaultValues: [],
                            allowEmpty: false
                          }
                        }
                      }
                    ],
                    defaultValues: [],
                    allowEmpty: false
                  }
                }
              }
            ],
            defaultValues: [],
            allowEmpty: false
          }
        }
      },
      {
        code: "test",
        name: "Test object within",
        dataType: {
          TAG: "Object",
          _0: [
            {
              key: "test_1",
              dataType: {
                TAG: "String",
                _0: {}
              }
            },
            {
              key: "test_2",
              dataType: {
                TAG: "String",
                _0: {}
              }
            },
            {
              key: "test_object",
              dataType: {
                TAG: "Object",
                _0: [
                  {
                    key: "test_object_1",
                    dataType: {
                      TAG: "String",
                      _0: {}
                    }
                  },
                  {
                    key: "test_object_2",
                    dataType: {
                      TAG: "String",
                      _0: {}
                    }
                  }
                ]
              }
            },
            {
              key: "test_3",
              dataType: {
                TAG: "Bool",
                _0: {
                  defaultValue: false
                }
              }
            },
            {
              key: "test_array_object",
              dataType: {
                TAG: "List",
                _0: {
                  itemSchema: [
                    {
                      key: "test_arr_obj_1",
                      dataType: {
                        TAG: "String",
                        _0: {}
                      }
                    },
                    {
                      key: "test_arr_obj_2",
                      dataType: {
                        TAG: "String",
                        _0: {}
                      }
                    }
                  ],
                  defaultValues: [],
                  allowEmpty: false
                }
              }
            }
          ]
        }
      },
      {
        code: "user",
        name: "User",
        dataType: {
          TAG: "Object",
          _0: [
            {
              key: "name",
              dataType: {
                TAG: "String",
                _0: {}
              }
            },
            {
              key: "surname",
              dataType: {
                TAG: "String",
                _0: {}
              }
            },
            {
              key: "payment_info",
              dataType: {
                TAG: "Object",
                _0: [
                  {
                    key: "card_number",
                    dataType: {
                      TAG: "String",
                      _0: {}
                    }
                  },
                  {
                    key: "cvc",
                    dataType: {
                      TAG: "Float",
                      _0: {}
                    }
                  },
                  {
                    key: "cardholder",
                    dataType: {
                      TAG: "Object",
                      _0: [
                        {
                          key: "name",
                          dataType: {
                            TAG: "String",
                            _0: {}
                          }
                        },
                        {
                          key: "surname",
                          dataType: {
                            TAG: "String",
                            _0: {}
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  },
  Blocks__Common.paddingSettingGroup,
  Blocks__Common.marginSettingGroup,
  Blocks__Common.sizingSettingGroup,
  Blocks__Common.borderSettingGroup,
  Blocks__Common.layoutSettingGroup,
  Blocks__Common.backgroundWithImageSettingGroup,
  Blocks__Common.opacitySettingGroup,
  Blocks__Common.absoluteLayoutSettingGroup
];

var descriptor = {
  meta: descriptor_meta,
  code: blockCode,
  component: Component,
  declaredTriggers: descriptor_declaredTriggers,
  declaredSettings: descriptor_declaredSettings
};

var version = 1;

var minRendererVersion = Renderer__Version.current;

export {
  Component ,
  descriptor ,
  blockCode ,
  version ,
  minRendererVersion ,
}
/* react/jsx-runtime Not a pure module */
